import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Pages
import Home from "./Page/Homepage";
import AdminLogin from "./Components/AdminPage/LoginPage/AdminLogin";
import DashboardConnectionpage from "./Components/AdminPage/Antherpage/AdminPageconnection/Dashboard";
import Testimonals from "./Components/AdminPage/Antherpage/AdminPageconnection/Testimonals";
import PostProjectprocess from "./Components/AdminPage/Antherpage/AdminPageconnection/postsProjectprocess";
import BlogsPageProcess from "./Components/AdminPage/Antherpage/AdminPageconnection/Blogspage";
import LeadsProcess from "./Components/AdminPage/Antherpage/AdminPageconnection/Leadspage";
import AboutPage from "./Page/AboutPage";
import VisionPage from "./Page/VisionPage";
import TestimonaldPage from "./Page/TestimonialsPage";
import Idmatchprocessinperpage from "./Components/Separtedcontentprocess/Separtedtestimonaldetails";
import BlogsPageMain from "./Page/Blogspage";
import BlogsIdMatchcard from "./Page/BlogIDmatchpage";
import ContactpagePageMain from "./Page/contactpage";
import ProjectSection from "./Components/Projectcard/Projectdesign";
import BlogDetail from "./Components/Blogspagecomponents/BlogssepartedcardInduzuval";
import ProjectManagementIdManagement from "./Page/ProjectPageIdmanage";
import Bannermangementprocess from "./Components/AdminPage/Antherpage/AdminPageconnection/BannerManagement";
import Projectpageconnection from "./Components/AdminPage/Antherpage/AdminPageconnection/ProjectPage";
import ProjectCategorysManagement from "./Components/AdminPage/Antherpage/AdminPageconnection/ProjectCategory";
import AmentiiesProcessPage from "./Components/AdminPage/Antherpage/AdminPageconnection/Ameniriescontrolpage";
import SpecificationControlPage from "./Components/AdminPage/Antherpage/AdminPageconnection/specificationcontrolpage";
import NearbyLocation from "./Components/AdminPage/Antherpage/AdminPageconnection/NearbyLocationprocess";
import Enquirydatatable from "./Components/AdminPage/Antherpage/AdminPageconnection/Enquiredprocess";
import PolicyProvacy from "./Page/Policy";
import TeamOfContent from "./Page/TeamOfUse";
import BlogsDetailsProcessSepretedidMantained from "./Page/Blogpageseprtedprocess";
import ProjectSepeficationprocess from "./Components/AdminPage/Antherpage/AdminPageconnection/SpeficationManagement";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Default Route */}
        <Route path="/" element={<Home />} />
        <Route path="/sampletes" element={<ProjectSection />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/about/vision-mission" element={<VisionPage />} />
        <Route path="/testimonials" element={<TestimonaldPage />} />
        <Route path="/testimonials/:id" element={<Idmatchprocessinperpage />} />
        <Route path="/project/:id" element={<ProjectManagementIdManagement />} />
        <Route path="/blog" element={<BlogsPageMain />} />
        <Route path="/contact" element={<ContactpagePageMain />} />
        <Route path="/privacy-policy" element={<PolicyProvacy />} />
        <Route path="/terms-of-use" element={<TeamOfContent />} />

        <Route path="/blog/:id" element={<BlogsDetailsProcessSepretedidMantained />} />
        <Route path="/admin/admindashbooard" element={<DashboardConnectionpage />} />
        <Route path="/admin/bannermanagement" element={<Bannermangementprocess />} />
        <Route path="/admin/Testmiminials" element={<Testimonals />} />
        <Route path="/admin/category" element={<ProjectCategorysManagement />} />
        <Route path="/admin/amenities" element={<AmentiiesProcessPage />} />
        <Route path="/admin/nearbylocation" element={<NearbyLocation />} />
        <Route path="/admin/specification" element={<SpecificationControlPage />} />
        <Route path="/admin/posts" element={<Projectpageconnection />} />
        <Route path="/admin/spefictionManagement" element={<ProjectSepeficationprocess />} />
        <Route path="/admin/messages" element={<LeadsProcess />} />
        <Route path="/admin/blog" element={<BlogsPageProcess />} />
        <Route path="/admin/pricing" element={<DashboardConnectionpage />} />
        <Route path="/admin/enquiry" element={<Enquirydatatable />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
    </Router>
  );
};

export default App;
